var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 28,
    viewBox: "0 0 87 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_6729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.668 8.91419C44.6187 12.7991 48.1302 14.9669 50.7753 16.2559C53.493 17.5783 54.4059 18.4264 54.3951 19.6092C54.3748 21.4191 52.2273 22.2179 50.2177 22.2489C46.7116 22.3032 44.673 21.3023 43.0524 20.5453L41.7893 26.4553C43.4154 27.2046 46.4262 27.858 49.5484 27.8867C56.8773 27.8867 61.672 24.269 61.698 18.6599C61.7267 11.5411 51.8515 11.1471 51.9189 7.96523C51.9422 7.00041 52.8628 5.97082 54.8802 5.70903C55.8787 5.57679 58.6352 5.47559 61.7604 6.91472L62.987 1.19665C61.3064 0.584696 59.1463 -0.00127983 56.457 -0.00127983C49.5588 -0.00127983 44.7071 3.66571 44.668 8.91419ZM74.7733 0.491249C73.4351 0.491249 72.3073 1.27188 71.804 2.4698L61.335 27.4667H68.6586L70.1159 23.4391H79.0651L79.9105 27.4667H86.3653L80.7326 0.491249H74.7733ZM75.7979 7.77833L77.9114 17.9079H72.1231L75.7979 7.77833ZM35.7886 0.491587L30.0159 27.4664H36.9946L42.7646 0.490913L35.7886 0.491587ZM25.4647 0.491587L18.2009 18.8518L15.2626 3.24031C14.9178 1.49756 13.5562 0.491249 12.0442 0.491249H0.170219L0.00390625 1.27457C2.44159 1.80354 5.21123 2.6567 6.88921 3.56956C7.9161 4.1272 8.20892 4.61467 8.54627 5.93978L14.1115 27.4667H21.4863L32.7929 0.491249L25.4647 0.491587Z",
    fill: "url(#paint0_linear_633_6729)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_633_6729",
    x1: 3970.38,
    y1: 83.83,
    x2: 4051.11,
    y2: -2780.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_6729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.37,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visaIcon.43857da834f103e071271c6bfe4ea3be.svg";
export { ForwardRef as ReactComponent };